<div class="notfound-wrapper flex items-center justify-center min-h-[80vh] px-4">
  <div class="glass-card relative max-w-lg w-full text-center p-8 md:p-12 rounded-3xl border border-[var(--mat-sys-outline-variant)] shadow-2xl overflow-hidden animate-fade-in">
    <!-- Glow effects behind -->
    <div class="glow-orb glow-1"></div>
    <div class="glow-orb glow-2"></div>

    <div class="relative z-10 flex flex-col items-center gap-6">
      <!-- High fidelity animated icon container -->
      <div class="error-badge-container relative flex items-center justify-center">
        <div class="pulse-ring"></div>
        <div class="error-badge flex items-center justify-center rounded-2xl bg-[var(--mat-sys-error-container)] border border-[var(--mat-sys-error)] text-[var(--mat-sys-error)]">
          <mat-icon class="error-icon text-5xl">warning_amber</mat-icon>
        </div>
      </div>

      <!-- Glitch effect numbers -->
      <div class="glitch-container select-none">
        <span class="glitch-text text-8xl font-black tracking-widest text-[var(--mat-sys-primary)]" data-text="404">404</span>
      </div>

      <!-- Text content -->
      <div class="flex flex-col gap-2">
        <h1 class="text-2xl md:text-3xl font-extrabold tracking-tight m-0 text-[var(--mat-sys-on-surface)]">
          {{ 'NOT_FOUND.PAGE_TITLE' | translate }}
        </h1>
        <p class="text-sm md:text-base text-[var(--mat-sys-on-surface-variant)] leading-relaxed max-w-sm mx-auto">
          {{ 'NOT_FOUND.PAGE_MESSAGE' | translate }}
        </p>
      </div>

      <!-- Action Button -->
      <div class="mt-4">
        <a mat-flat-button routerLink="/" class="return-home-btn rounded-full px-8 py-6 flex items-center gap-2 font-semibold text-white tracking-wide transition-all">
          <mat-icon class="button-icon transition-transform">home</mat-icon>
          <span>{{ 'NOT_FOUND.RETURN_HOME' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
